<div class="container mt-4">
  <div class="row mb-5">
    <div class="col-12 col-md-6 offset-md-3 col-lg-4 offset-lg-4 mb-3">
      <ngb-alert *ngIf="alert" [type]="alert.type" (closed)="closeAlert()" class="sticky-top" style="top: 10px;">{{ alert.message }}</ngb-alert>

      <h3 class="mt-5 mb-3">Please set a password below to complete your pet’s microchip account</h3>

      <form
        #passwordForm="ngForm"
        (ngSubmit)="claimAccount()"
        [appMatchingFields]="['password', 'passwordConfirm']"
        novalidate>

        <div class="mb-3">
          <div>
            <label class="form-label" for="password"> Password </label>
          </div>
          <div>
            <mat-form-field appearance="outline" class="w-100">
              <input
                matInput
                #password="ngModel"
                [type]="hidePassword ? 'password' : 'text'"
                [class.is-invalid]="password.touched && !password.valid"
                id="password"
                minlength="8"
                name="password"
                [(ngModel)]="model.password"
                placeholder="Password"
                required
              />
              <button
                type="button"
                mat-icon-button
                matSuffix
                (click)="hidePassword = !hidePassword"
                [attr.aria-label]="'Hide password'"
                [attr.aria-pressed]="hidePassword"
              >
                <mat-icon>{{
                  hidePassword ? "visibility_off" : "visibility"
                }}</mat-icon>
              </button>
              <mat-error
                *ngIf="
                  (password.errors && password.errors.minlength) ||
                  (password.errors && password.errors.required)
                "
              >
                {{
                  password.errors && password.errors.minlength
                    ? errorStrings.passwordTooShort
                    : errorStrings.required
                }}
              </mat-error>
            </mat-form-field>
            <app-password-strength
              [passwordToCheck]="model.password"
            ></app-password-strength>
          </div>
        </div>

        <div>
            <label class="form-label" for="passwordConfirm"> Confirm password </label>
          </div>
          <div>
            <mat-form-field appearance="outline" class="w-100">
              <input
                matInput
                #passwordConfirm="ngModel"
                [type]="hideConfirmPassword ? 'password' : 'text'"
                [class.is-invalid]="
                  passwordConfirm.touched && !passwordConfirm.valid
                "
                id="passwordConfirm"
                minlength="8"
                name="passwordConfirm"
                ngModel=""
                placeholder="Confirm password"
                required
              />
              <button
                mat-icon-button
                type="button"
                matSuffix
                (click)="hideConfirmPassword = !hideConfirmPassword"
                [attr.aria-label]="'Hide password'"
                [attr.aria-pressed]="hideConfirmPassword"
              >
                <mat-icon>{{
                  hideConfirmPassword ? "visibility_off" : "visibility"
                }}</mat-icon>
              </button>
              <mat-error
                *ngIf="
                  (passwordConfirm.errors &&
                    passwordConfirm.errors.required) ||
                  (passwordConfirm.errors &&
                    passwordConfirm.errors.minlength) ||
                  (passwordConfirm.errors &&
                    passwordConfirm.errors.matchingFields)
                "
              >
                {{
                  passwordConfirm.errors && passwordConfirm.errors.required
                    ? errorStrings.required
                    : passwordConfirm.errors &&
                      passwordConfirm.errors.minlength
                    ? errorStrings.passwordTooShort
                    : errorStrings.passwordMismatch
                }}
              </mat-error>
            </mat-form-field>
          </div>

        <button
         type="submit"
         class="btn btn-success text-white btn-lg w-100 mt-5"
         [disabled]="!passwordForm.valid || loading">
          <fa-icon *ngIf="loading" [icon]="['fas', 'spinner']" [animation]="'spin'" class="me-3"></fa-icon>
          {{ loading ? 'Claim account...' : 'Claim account' }}
        </button>
      </form>
    </div>
  </div>
</div>
